// extracted by mini-css-extract-plugin
module.exports = {"App":"App_App__2nH6n","Header":"App_Header__3_5Bg","Main":"App_Main__3zRHv","Footer":"App_Footer__3Xzdz"};